import { CalendarDays } from "lucide-react";

export function HouseBeerPromo({ showBooking = false }: { showBooking?: boolean }) {
  return (
    <section className="house-beer-promo" aria-labelledby="house-beer-heading">
      <div className="container house-beer-grid">
        <img
          className="house-beer-image"
          src="/manus-storage/house-beer-fish-amok-1600_7383dfbf.webp"
          srcSet="/manus-storage/house-beer-fish-amok-640_fed80a23.webp 640w, /manus-storage/house-beer-fish-amok-960_fa5dda68.webp 960w, /manus-storage/house-beer-fish-amok-1600_7383dfbf.webp 1600w"
          sizes="(max-width: 767px) calc(100vw - 32px), (max-width: 1199px) 45vw, 560px"
          alt="Fish Amok in banana leaf beside a cold glass of Angkor House Beer"
          width="1600"
          height="1600"
          loading="lazy"
          decoding="async"
        />
        <div className="house-beer-copy">
          <h2 id="house-beer-heading">New: Angkor House Beer</h2>
          <p>Our own house beer, made to pair with our signature Fish Amok. Pouring from Tuesday 13 October.</p>
          {showBooking && (
            <a href="https://reserve.oddle.me/en_AU/angkorcafe" className="button button-dark">
              Book a table <CalendarDays size={17} aria-hidden="true" />
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
